import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PresenceService } from './services/presence.service';
import { CallService } from './services/call.service';
import { EchoService } from './services/echo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  // title = 'Umyo Sports Cards';

  private lastToken: string | null = null;

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private router: Router,
    private presence: PresenceService,
    private callService: CallService,
    private echoService: EchoService
  ) {
    // this.titleService.setTitle(this.title);
  }

  ngOnInit(): void {
    // har navigation ke baad check: login/logout/user badalne par realtime restart
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.syncRealtime());

    this.syncRealtime();   // page refresh par bhi chale
  }

  private syncRealtime(): void {
    const token = localStorage.getItem('access_token');
    if (token === this.lastToken) return;   // kuch nahi badla
    this.lastToken = token;

    this.presence.stop();
    this.callService.stop();
    this.echoService.disconnect();          // purana token wala Echo khatam

    if (token && localStorage.getItem('user_id')) {
      this.presence.start();
      this.callService.listen();
    }
  }
}